import React, { useMemo } from 'react';

import { Box, Stack, Typography } from '@mui/material';

import { CharterFlight, SeatSelectionState, Traveller } from '../charter.types';
import { CABIN_CLASS_LABELS, getUsedCabinClassesForFlight } from '../common/flightAssignments';

import SeatRow from './SeatRow';

type FlightSeatMapProps = {
  flight: CharterFlight;
  seatSelections: SeatSelectionState;
  travellers: Array<Traveller>;
};

export default function FlightSeatMap({ flight, seatSelections, travellers }: FlightSeatMapProps): React.JSX.Element {
  const usedCabins = useMemo(() => getUsedCabinClassesForFlight(flight, travellers), [flight, travellers]);
  const filteredRows = useMemo(() => {
    return flight.cabinLayout.filter((row) => usedCabins.includes(row.cabin));
  }, [flight.cabinLayout, usedCabins]);

  return (
    <Stack spacing={2} alignItems="center" sx={{ width: '100%' }}>
      <Box sx={{ width: '100%', mb: 1 }}>
        <Typography variant="h6" sx={{ textAlign: 'left', fontWeight: 600 }}>
          {usedCabins.map((cabin) => CABIN_CLASS_LABELS[cabin]).join(' / ')}
        </Typography>
      </Box>
      <Stack spacing={1} alignItems="center" sx={{ width: '100%' }}>
        {filteredRows.map((row) => (
          <SeatRow
            key={`${flight.id}-${row.rowId}`}
            row={row}
            flightId={flight.id}
            seatSelections={seatSelections}
            travellers={travellers}
          />
        ))}
      </Stack>
    </Stack>
  );
}
